// Remote-Cursor-Layer im Worldspace. Wird in Canvas innerhalb von canvas-world gerendert,
// damit Pan/Zoom mit den Cursors mitwandert.

import type { RemotePresence } from "../realtime/use-awareness.js";

interface RemoteCursorsProps {
  presences: readonly RemotePresence[];
  zoom: number;
}

export function RemoteCursors({ presences, zoom }: RemoteCursorsProps): JSX.Element {
  // Gegen-Skalierung damit Cursor-Groesse zoom-unabhaengig bleibt.
  const counterScale = 1 / zoom;
  return (
    <>
      {presences.map((p) => {
        if (!p.cursor) return null;
        return (
          <div
            key={p.clientId}
            className="canvas-remote-cursor"
            style={{
              left: p.cursor.x,
              top: p.cursor.y,
              color: p.user.color,
              transform: `scale(${counterScale})`,
              transformOrigin: "0 0",
            }}
          >
            <svg viewBox="0 0 16 16" width={16} height={16} aria-hidden="true">
              <path
                d="M1 1 L1 12 L4 9 L7 14 L9 13 L6 8 L11 8 Z"
                fill="currentColor"
                stroke="#fff"
                strokeWidth="0.8"
              />
            </svg>
            <span className="canvas-remote-cursor-label" style={{ background: p.user.color }}>
              {p.user.name}
            </span>
          </div>
        );
      })}
    </>
  );
}
